function pagePathKey(pathname: string): string {
  const decoded = decodeURIComponent(pathname);
  const trimmed = decoded.replace(/\/+$/, '') || '/';
  const withoutHtml = trimmed.replace(/\.html?$/i, '');
  return withoutHtml.toLowerCase();
}

function canonicalizeHome(key: string): string {
  if (key === '/index' || key === '/index.php') {
    return '/';
  }
  return key;
}

function hrefPathKey(href: string): string | null {
  try {
    const u = new URL(href, window.location.href);
    return canonicalizeHome(pagePathKey(u.pathname));
  } catch {
    return null;
  }
}

export function initHeaderNavActiveState(): void {
  const root = document.querySelector<HTMLElement>('.header.header-desktop .navbar-nav');
  if (!root) return;

  const currentKey = canonicalizeHome(pagePathKey(window.location.pathname));

  root.querySelectorAll<HTMLAnchorElement>('.nav-item > .nav-link').forEach((link) => {
    link.classList.remove('active');
    link.removeAttribute('aria-current');
  });

  root.querySelectorAll<HTMLLIElement>(':scope > li.nav-item').forEach((item) => {
    const toggle = item.querySelector<HTMLAnchorElement>(':scope > .nav-link');
    if (!toggle?.href) return;

    if (item.classList.contains('dropdown')) {
      const keys: string[] = [];
      const pushKey = (a: HTMLAnchorElement) => {
        const k = hrefPathKey(a.href);
        if (k !== null) keys.push(k);
      };
      pushKey(toggle);
      item.querySelectorAll<HTMLAnchorElement>('.dropdown-menu .dropdown-item[href]').forEach(pushKey);

      if (keys.some((k) => k === currentKey)) {
        toggle.classList.add('active');
        toggle.setAttribute('aria-current', 'page');
      }
    } else {
      const k = hrefPathKey(toggle.href);
      if (k !== null && k === currentKey) {
        toggle.classList.add('active');
        toggle.setAttribute('aria-current', 'page');
      }
    }
  });
}
